var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.70826 13.1888C3.41243 13.1888 0.729095 10.5055 0.729095 7.20964C0.729095 3.9138 3.41243 1.23047 6.70826 1.23047C10.0041 1.23047 12.6874 3.9138 12.6874 7.20964C12.6874 10.5055 10.0041 13.1888 6.70826 13.1888ZM6.70826 2.10547C3.89076 2.10547 1.6041 4.39797 1.6041 7.20964C1.6041 10.0213 3.89076 12.3138 6.70826 12.3138C9.52576 12.3138 11.8124 10.0213 11.8124 7.20964C11.8124 4.39797 9.52576 2.10547 6.70826 2.10547Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8333 13.7707C12.7225 13.7707 12.6116 13.7298 12.5241 13.6423L11.3575 12.4757C11.1883 12.3065 11.1883 12.0265 11.3575 11.8573C11.5266 11.6882 11.8066 11.6882 11.9758 11.8573L13.1425 13.024C13.3116 13.1932 13.3116 13.4732 13.1425 13.6423C13.055 13.7298 12.9441 13.7707 12.8333 13.7707Z",
    fill: "#C4C4C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.75b48022fa33d1954f18e2a0d6386cdc.svg";
export { ForwardRef as ReactComponent };